import React from 'react';

import './style.scss';
import CButton from '../CButton';

/**
 * @param {*} value 
 * @param {*} tabs Array of tab objects [{label: string, value: string|number}] or array of string
 * @param {Object} children Dom element
 * @param {function} onChange  Returns tab index or if tab is object return value
 */

const CTabs = ({value, tabs = [], children, onChange}) => {
    return (
        <div className="c-tabs">
            {!!tabs?.length &&
                <div className="c-tabs-buttons container-scroll container-scroll--horizontal">
                    {tabs?.map((tab, index) => (
                        <CButton
                            key={index}
                            blank
                            className={`c-tabs-button ${tab?.value === value ?? tab === value ? 'active' : ''}`}
                            label={typeof tab === 'string' ? tab : tab.label}
                            onClick={() => onChange(typeof tab === 'string' ? index : tab.value)}
                        />
                    ))}
                </div>
            }
            {
                children &&
                <div className="c-tabs-children">
                    {children}
                </div>
            }
        </div>
    )
};

export default CTabs;
